import React from 'react';
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  SafeAreaView,
  ScrollView,
} from '../utils/webComponents';
import { useNavigation } from '../utils/navigation';
import { useTheme } from '../context/ThemeContext';
import { useTranslation } from '../hooks/useTranslation';
import { ArrowBack } from '@mui/icons-material';

const HelpCenterScreen = () => {
  const navigation = useNavigation();
  const { theme } = useTheme();
  const { t } = useTranslation();

  return (
    <SafeAreaView style={[styles.container, { backgroundColor: theme.background }]}>
      <View style={styles.header}>
        <TouchableOpacity
          style={styles.backButton}
          onPress={() => navigation.goBack()}
        >
          <ArrowBack sx={{ fontSize: 24, color: theme.text }} />
        </TouchableOpacity>
        <Text style={[styles.headerTitle, { color: theme.text }]}>{t('help.title')}</Text>
        <View style={{ width: 40 }} />
      </View>
      <ScrollView
        style={styles.scrollView}
        contentContainerStyle={[styles.scrollContent, { alignItems: 'center' }]}
      >
        <View style={styles.content}>
          <Text style={[styles.sectionTitle, { color: theme.text }]}>
            {t('help.frequentlyAskedQuestions')}
          </Text>

          <View style={styles.section}>
            <Text style={[styles.sectionTitle, { color: theme.text }]}>
              {t('help.contactSupport')}
            </Text>
            <Text p style={[styles.paragraph, { color: theme.textSecondary }]}>
              {t('help.contactSupportText').replace(/\n/g, ' ')}
            </Text>
          </View>

          <View style={styles.section}>
            <Text style={[styles.sectionTitle, { color: theme.text }]}>
              {t('help.gettingStarted')}
            </Text>

            <Text style={[styles.question, { color: theme.text }]}>
              {t('help.howToCreateClass')}
            </Text>
            <Text p style={[styles.paragraph, { color: theme.textSecondary }]}>
              {t('help.howToCreateClassAnswer').replace(/\n/g, ' ')}
            </Text>

            <Text style={[styles.question, { color: theme.text }]}>
              {t('help.howToCreateFlashcards')}
            </Text>
            <Text p style={[styles.paragraph, { color: theme.textSecondary }]}>
              {t('help.howToCreateFlashcardsAnswer').replace(/\n/g, ' ')}
            </Text>

            <Text style={[styles.question, { color: theme.text }]}>
              {t('help.howToUseAI')}
            </Text>
            <Text p style={[styles.paragraph, { color: theme.textSecondary }]}>
              {t('help.howToUseAIAnswer').replace(/\n/g, ' ')}
            </Text>
          </View>

          <View style={styles.section}>
            <Text style={[styles.sectionTitle, { color: theme.text }]}>
              {t('help.features')}
            </Text>

            <Text style={[styles.question, { color: theme.text }]}>
              {t('help.whatIsSpacedRepetition')}
            </Text>
            <Text p style={[styles.paragraph, { color: theme.textSecondary }]}>
              {t('help.whatIsSpacedRepetitionAnswer').replace(/\n/g, ' ')}
            </Text>

            <Text style={[styles.question, { color: theme.text }]}>
              {t('help.howDoesSpacedRepetitionWork')}
            </Text>
            <Text p style={[styles.paragraph, { color: theme.textSecondary }]}>
              {t('help.howDoesSpacedRepetitionWorkAnswer').replace(/\n/g, ' ')}
            </Text>

            <Text style={[styles.question, { color: theme.text }]}>
              {t('help.canIUseOffline')}
            </Text>
            <Text p style={[styles.paragraph, { color: theme.textSecondary }]}>
              {t('help.canIUseOfflineAnswer').replace(/\n/g, ' ')}
            </Text>
          </View>

          <View style={styles.section}>
            <Text style={[styles.sectionTitle, { color: theme.text }]}>
              {t('help.account')}
            </Text>

            <Text style={[styles.question, { color: theme.text }]}>
              {t('help.howToDeleteAccount')}
            </Text>
            <Text p style={[styles.paragraph, { color: theme.textSecondary }]}>
              {t('help.deleteAccountAnswer').replace(/\n/g, ' ')}
            </Text>
          </View>

          <View style={styles.section}>
            <Text style={[styles.sectionTitle, { color: theme.text }]}>
              {t('help.stillNeedHelp')}
            </Text>
            <Text p style={[styles.paragraph, { color: theme.textSecondary }]}>
              {t('help.stillNeedHelpText').replace(/\n/g, ' ')}
            </Text>
          </View>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  header: {
    paddingHorizontal: 24,
    paddingTop: 20,
    paddingBottom: 16,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  backButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  headerTitle: {
    fontSize: 24,
    fontWeight: '700',
    flex: 1,
    textAlign: 'center',
  },
  scrollView: {
    flex: 1,
  },
  scrollContent: {
    paddingBottom: 40,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  content: {
    maxWidth: 700,
    width: 'calc(100% - 48px)',
    paddingHorizontal: 24,
    paddingTop: 24,
    paddingBottom: 40,
  },
  title: {
    fontSize: 32,
    fontWeight: '700',
    marginBottom: 40,
    textAlign: 'center',
    display: 'block',
  },
  section: {
    marginBottom: 32,
  },
  sectionTitle: {
    fontSize: 22,
    fontWeight: '600',
    marginBottom: 12,
    textAlign: 'center',
    display: 'block',
  },
  question: {
    fontSize: 18,
    fontWeight: '600',
    marginTop: 24,
    marginBottom: 8,
    textAlign: 'center',
    display: 'block',
  },
  paragraph: {
    fontSize: 16,
    lineHeight: '1.6',
    textAlign: 'center',
    marginTop: 0,
    marginBottom: 16,
    marginLeft: 0,
    marginRight: 0,
    padding: 0,
  },
});

export default HelpCenterScreen;
